<template>
  <div class="home">
    <!-- <el-alert title="提示：为了您有更好的学习体验，推荐使用谷歌浏览器！" type="warning" center show-icon></el-alert> -->
    <div class="content">
      <!-- <div class="lang">
        <p>住房和城乡建设领域施工现场专业人员培训平台</p>
      </div>-->
      <div class="title">
        <!-- <p>住房和城乡建设领域</p>
        <p>施工现场专业人员继续教育平台</p>-->
        <p>湖北省建设教育协会网络学习平台</p>
      </div>
      <div class="login bs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="学员" name="first">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" style="padding: 0 50px">
              <el-form-item prop="user">
                <el-input
                  prefix-icon="el-icon-user-solid"
                  v-model="ruleForm.user"
                  placeholder="请输入身份证号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input
                  type="password"
                  v-model="ruleForm.pass"
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  placeholder="密码"
                  clearable
                  @keyup.enter.native="student('ruleForm')"
                ></el-input>
              </el-form-item>
              <el-row>
                <!-- <a href="http://bdy.eceyun.net/user/">
                <el-button type="primary">登录</el-button>
                </a>-->
                <el-button style="width: 100%" type="primary" @click="student('ruleForm')">登录</el-button>
              </el-row>
              <el-row>
                <el-button
                  style="width: 100%; margin-top: 10px"
                  type="primary"
                  @click="chooseDialog = true"
                >个人注册</el-button>
              </el-row>
              <el-row class="enter">
                <span class="cur" @click="forgetDialog = true">忘记密码?</span>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="培训机构" name="second">
            <el-form
              ref="companyForm"
              :model="companyForm"
              :rules="companyRule"
              style="padding: 0 50px"
            >
              <el-form-item prop="name">
                <el-input
                  v-model="companyForm.name"
                  prefix-icon="el-icon-user-solid"
                  placeholder="企业用户名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input
                  type="password"
                  v-model="companyForm.pass"
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  placeholder="密码"
                  @keyup.enter.native="organLogin('companyForm')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-row>
                <!-- <a href="http://bdy.eceyun.net/school/" target="_blank"> -->
                <el-button style="width: 100%" type="primary" @click="organLogin('companyForm')">登录</el-button>
                <!-- </a> -->
                <!-- <div class="enter">
                <span class="cur" @click="firmDialog = true">企业注册</span>
                </div>-->
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="管理部门" name="third">
            <el-form
              ref="manageForm"
              :model="manageForm"
              :rules="manageRule"
              style="padding: 0 50px"
            >
              <el-form-item>
                <el-input
                  v-model="manageForm.name"
                  prefix-icon="el-icon-user-solid"
                  placeholder="管理账号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  type="password"
                  v-model="manageForm.pass"
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  placeholder="密码"
                  @keyup.enter.native="chartLogin('manageForm')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item class="bot">
                <el-button style="width: 100%" type="primary" @click="chartLogin('manageForm')">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <p class="tip">提示：为了您有更好的学习体验，推荐使用谷歌浏览器！</p>
    </div>
    <!-- 忘记密码弹框 -->
    <el-dialog
      class="forgetPop"
      title="忘记密码"
      :visible.sync="forgetDialog"
      width="40%"
      center
      @close="resetForm('forgetForm')"
    >
      <el-form
        class="info forget"
        ref="forgetForm"
        :model="forgetForm"
        :rules="forgetRule"
        label-width="100px"
      >
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="forgetForm.name" placeholder="请输入姓名" clearable autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="card">
          <el-input
            v-model="forgetForm.card"
            @blur="getPhone"
            placeholder="请输入身份证号"
            autocomplete="off"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newpsd">
          <el-input
            type="password"
            v-model="forgetForm.newpsd"
            placeholder="请输入新密码"
            autocomplete="new-password"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="surepsd">
          <el-input type="password" v-model="forgetForm.surepsd" placeholder="请输入确认密码" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <div class="telbox flex">
            <el-input
              class="telIpt"
              v-model="forgetForm.phone"
              placeholder="请输入手机号"
              :disabled="phoneDisabled"
            ></el-input>
            <el-button
              class="code"
              type="primary"
              @click="getForgetBtn"
              :disabled="isDisabled"
            >获取验证码</el-button>
          </div>
          <!-- <el-input
            v-model="forgetForm.phone"
            placeholder="请输入手机号"
            :disabled="phoneDisabled"
          ></el-input>
          <el-button
            class="code"
            type="primary"
            @click="getForgetBtn"
            :disabled="isDisabled"
          >获取验证码</el-button>-->
        </el-form-item>
        <el-form-item label="验证码：" prop="code">
          <el-input v-model="forgetForm.code" placeholder="请输入验证码" clearable></el-input>
        </el-form-item>
        <el-form-item class="create">
          <el-button type="primary" @click="forgetCommit('forgetForm')">提交</el-button>
          <el-button type="primary" plain @click="forgetDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 选择培训机构 -->
    <el-dialog
      class="choosePop"
      title="选择培训机构"
      :visible.sync="chooseDialog"
      width="50%"
      center
      top="6vh"
      @open="getOrganList"
      @close="resetForm('chooseForm')"
    >
      <el-form
        class="info infoTeachingApplicate"
        :inline="true"
        ref="chooseForm"
        :model="chooseForm"
      >
        <el-form-item>
          <v-distpicker
            :province="select.province"
            :city="select.city"
            hide-area
            @province="onChangeProvince"
            @city="onChangeCity"
            @area="onChangeArea"
            @selected="selected"
          ></v-distpicker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="chooseForm.name"
            placeholder="请输入培训机构"
            @keyup.enter.native="selectBtn"
            clearable
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="selectBtn">搜索</el-button>
      </el-form>
      <el-table
        :data="organList"
        border
        max-height="460"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :header-cell-style="{ background: '#dde9fc', color: '#606266' }"
        @row-click="rowClick"
      >
        <!-- @current-change="currentChange" -->
        <!-- <el-table-column type="selection" width="50"></el-table-column> -->
        <!-- <el-table-column type="index" width="50" label="序号"></el-table-column> -->
        <el-table-column prop="entpCity" label="所属城市" min-width="80"></el-table-column>
        <el-table-column prop="entpName" label=" " min-width="160"></el-table-column>
      </el-table>
      <pagination
        :currentPage="currentPage"
        :total="total"
        :limit="limit"
        ref="page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <el-row style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="chooseBtn">确认选择</el-button>
      </el-row>
    </el-dialog>
    <!-- 个人注册 -->
    <el-dialog
      class="registerPop"
      title="个人注册"
      :visible.sync="loginDialog"
      width="60%"
      center
      top="6vh"
      @open="getPostList"
      @close="resetForm('loginForm')"
    >
      <el-form
        class="info infoLogin"
        ref="loginForm"
        :model="loginForm"
        :rules="loginRule"
        label-width="135px"
      >
        <el-form-item label="上传证件照：" ref="imageUrl" prop="imageUrl">
          <img class="inline exam" src="../assets/images/exam.jpg" alt />
          <el-upload
            class="avatar-uploader inline"
            accept="image/jpg, image/jpeg, image/gif, image/png"
            :action="uploadUrl"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            :on-progress="handleProgress"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              <h3>请上传符合要求的头像照片，否则证书记录将无效：</h3>
              <p>（1）本人近三个月内的正面、免冠、无妆、彩色（限白底色）电子证件照片；</p>
              <p>（2）照片类型为jpg、png格式，照片大小不超过80K；</p>
              <p>（3）照片须显示双耳、双眉、双肩；</p>
              <p>（4）不得上传全身照、半身照、风景照、生活照等；</p>
              <p>（5）不得进行过度PS处理，不得美颜；</p>
              <p>（6）不得佩戴首饰、头饰。</p>
            </div>
          </el-upload>
        </el-form-item>
        <div class="line">
          <el-form-item class="fl" label="姓名：" prop="name">
            <el-input v-model="loginForm.name" placeholder="请输入姓名" clearable></el-input>
          </el-form-item>
          <el-form-item class="sex fl" label="性别：" prop="sex">
            <el-radio v-model="loginForm.sex" label="0">男</el-radio>
            <el-radio v-model="loginForm.sex" label="1">女</el-radio>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="身份证号：" prop="card">
            <el-input
              v-model="loginForm.card"
              placeholder="请输入身份证号"
              clearable
              @blur="analyzeIDCard"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属企业：" prop="company">
            <el-input v-model="loginForm.company" placeholder="请输入企业名称" clearable></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="选择专业：" prop="special">
            <el-select v-model="loginForm.special" placeholder="请选择专业" clearable>
              <el-option
                v-for="(item, i) in specialList"
                :key="i"
                :label="item.postName"
                :value="item.postId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学历：" prop="regOldPost">
            <el-select v-model="loginForm.regOldPost" placeholder="请选择学历" clearable>
              <el-option label="中职（含技工学校）" value="中职（含技工学校）"></el-option>
              <el-option label="专科（含高职和技师学院）" value="专科（含高职和技师学院）"></el-option>
              <el-option label="本科及以上" value="本科及以上"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="手机号：" prop="phone">
            <div class="telbox flex">
              <el-input class="telIpt" v-model="loginForm.phone" placeholder="请输入手机号" clearable></el-input>
              <el-button class="code" type="primary" @click="CodeBtn" :disabled="isDisabled">获取验证码</el-button>
            </div>
          </el-form-item>
          <el-form-item label="验证码：" prop="code">
            <el-input v-model="loginForm.code" placeholder="请输入验证码" clearable></el-input>
          </el-form-item>
        </div>

        <!-- <div class="line">
          <el-form-item label="报名类型：" prop="dataType">
            <el-select
              v-model="loginForm.dataType"
              placeholder="请选择报名类型"
              clearable
            >
              <el-option
                v-for="(item, i) in dataTypeList"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
        </el-form-item>-->
        <div class="line">
          <el-form-item label="继续教育年份：" prop="learnYear">
            <el-input v-model="loginForm.learnYear" placeholder="请输入继续教育年份" clearable></el-input>
          </el-form-item>
          <el-form-item label="证书编号：" prop="regCertificateNum">
            <el-input v-model="loginForm.regCertificateNum" placeholder="请输入证书编号" clearable></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="证书发证时间：" prop="regCertificateDate">
            <!-- <el-input
              v-model="loginForm.regCertificateDate"
              placeholder="证书发证时间"
              clearable
            ></el-input>-->
            <el-date-picker
              style="width: 100%;"
              v-model="loginForm.regCertificateDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
        </div>
        <el-form-item class="create">
          <el-button type="primary" @click="register('loginForm')">确定</el-button>
          <div class="enter">
            <span class="cur" @click="sign">已经注册? 立即登录</span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 企业注册 -->
    <el-dialog
      title="企业注册"
      :visible.sync="firmDialog"
      width="50%"
      center
      @close="resetForm('firmForm')"
    >
      <el-form class="info" ref="firmForm" :model="firmForm" :rules="firmRule" label-width="140px">
        <div class="line">
          <el-form-item label="公司名称：" prop="name">
            <el-input v-model="firmForm.name" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="信用代码：" prop="code">
            <el-input v-model="firmForm.code" placeholder="请输入信用代码"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="法人姓名：" prop="legalName">
            <el-input v-model="firmForm.legalName" placeholder="请输入法人姓名"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证号：" prop="card">
            <el-input v-model="firmForm.card" placeholder="请输入法人身份证号"></el-input>
          </el-form-item>
        </div>
        <div class="line">
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="firmForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
        </div>
        <el-form-item class="create">
          <el-button type="primary" @click="firmSure('firmForm')">注册</el-button>
          <div class="enter">
            <span class="cur" @click="firmLogin">已经注册? 去登录</span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import http from "../api/login";
import { bizURL, IsLocal } from "../api/baseUrl";
import pagination from "../components/pagination";
import VDistpicker from "v-distpicker";

export default {
  name: "login",
  components: {
    pagination,
    VDistpicker
  },
  data() {
    // 校验密码
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.forgetForm.newpsd !== "") {
          this.$refs.forgetForm.validateField("newpsd");
        }
        callback();
      }
    };
    // 确认密码
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.forgetForm.surepsd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    // 图片验证
    var valiIcon = (rule, value, callback) => {
      if (!this.imageUrl) {
        // hasFmt设置为true/false
        callback(new Error("请上传证件照"));
      } else {
        callback();
      }
    };
    return {
      activeName: "first",
      currentPage: 1, // 当前页
      limit: 10, // 每页显示数量
      total: 0, // 总条目数
      isDisabled: false, // 验证码状态
      phoneDisabled: false, // 手机号状态
      loading: true,
      entpId: "",
      specialList: [],
      uploadUrl: bizURL + "/employee/uploadImage",
      imageUrl: "",
      fileList: [],
      organList: [],
      ruleForm: {},
      chooseDialog: false,
      chooseForm: {
        name: ""
      },
      select: { province: "湖北省", city: "" },
      loginDialog: false,
      loginForm: {
        name: "",
        sex: "0",
        card: "",
        company: "",
        phone: "",
        code: "",
        regCertificateNum: "",
        regCertificateDate: "",
        special: "",
        regOldPost: "",
        learnYear: ""
      },
      dataTypeList: [
        {
          label: "换证",
          value: "0"
        },
        {
          label: "继教",
          value: "1"
        }
      ],

      forgetDialog: false,
      forgetForm: {
        name: "",
        card: "",
        newpsd: "",
        surepsd: "",
        phone: "",
        code: ""
      },
      companyForm: {},
      manageForm: {},
      firmDialog: false,
      firmForm: {
        name: "",
        code: "",
        legalName: "",
        card: "",
        phone: ""
      },
      rules: {
        user: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      loginRule: {
        imageUrl: [{ required: true, validator: valiIcon }],
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        card: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/,
            message: "证件号码格式有误！若号码中有字母请大写",
            trigger: "blur"
          }
        ],
        company: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        special: [{ required: true, message: "请选择专业", trigger: "change" }],
        regOldPost: [
          { required: true, message: "请选择学历", trigger: "change" }
        ],
        learnYear: [
          { required: true, message: "请选择继续教育年份", trigger: "blur" },
          {
            pattern: /^20\d{2}$/,
            message: "请输入正确的继续教育年份",
            trigger: "blur"
          }
        ],
        regCertificateNum: [
          { required: true, message: "请输入证书编号", trigger: "blur" }
        ],
        regCertificateDate: [
          { required: true, message: "请选择证书发证日期", trigger: "change" }
        ]
      },
      forgetRule: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        card: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/,
            message: "证件号码格式有误！若号码中有字母请大写",
            trigger: "blur"
          }
        ],
        newpsd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        // newpsd: [{ required: true, validator: validatePass, trigger: "blur" }],
        surepsd: [
          { required: true, message: "请输入确认密码", trigger: "blur" }
        ],
        // surepsd: [{ required: true, validator: validatePass2, trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },

      firmRule: {
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入信用代码", trigger: "blur" }],
        legalName: [
          { required: true, message: "请输入法人姓名", trigger: "blur" }
        ],
        card: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{17}([0-9]|X)$)/,
            message: "证件号码格式有误！若号码中有字母请大写",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不对",
            trigger: "blur"
          }
        ]
      },
      companyRule: {},
      manageRule: {}
    };
  },
  created() {
    var type = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      ? "mobile"
      : "PC";
    if (type == "mobile") {
      this.$router.push({
        path: "/null"
      });
      this.fullscreenLoadingfullscreenLoading = false;
      return false;
    }
    localStorage.clear();
  },
  mounted() {
    console.log(IsLocal, "IsLocal");
  },
  methods: {
    analyzeIDCard() {
      if (this.loginForm.card == "" || this.loginForm.card.length != 18) {
        return false;
      }
      this.loginForm = JSON.parse(JSON.stringify(this.loginForm));
      // 获取用户身份证号码
      const userCard = this.loginForm.card;
      // 获取性别
      if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
        this.loginForm.sex = "0";
      } else {
        this.loginForm.sex = "1";
      }
      // 获取出生年月日
      // const yearBirth = userCard.substring(6, 10)
      // const monthBirth = userCard.substring(10, 12)
      // const dayBirth = userCard.substring(12, 14)
      // this.loginForm.regBirthdate = yearBirth + '-' + monthBirth + '-' + dayBirth
    },
    /* 弹框表单清空 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.select.city = "";
      // this.$refs.upload.clearFiles();   //清空图片数组
    },
    // 学员登录
    student(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .studentLogin({
              empUname: this.ruleForm.user,
              empUpass: this.ruleForm.pass
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                var data = data.data.data;
                var tokenId = data.tokenId;
                this.entpId = data.entpId;
                localStorage.setItem("tokenId", data.tokenId);
                sessionStorage.setItem("username", data.userName);
                sessionStorage.setItem("token", data.tokenId);
                sessionStorage.setItem("entpId", data.entpId);
                this.$router.push({
                  path: "/home"
                });
                // this.$confirm(
                //   "您学习完视频后，记得完成在线测试，请知悉！！！",
                //   "提示",
                //   {
                //     confirmButtonText: "确定",
                //     cancelButtonText: "已了解",
                //     type: "warning",
                //     customClass: "show_confirm_black",
                //   }
                // )
                //   .then()
                //   .catch();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {
              this.$message.error({
                duration: 1000,
                message: "请求失败,请联系管理员!"
              });
            });
        } else {
          return false;
        }
      });
    },
    // 培训机构登录
    organLogin(formName) {},
    rowClick(row, column, event) {
      // console.log(row, "row");
      this.entpId = row.entpId;
    },
    // 确认选择
    chooseBtn() {
      if (this.entpId) {
        // this.chooseDialog = false;
        this.loginDialog = true;
      } else {
        this.$message.warning({
          duration: 1000,
          message: "请选择培训机构!"
        });
      }
    },
    // 获取注册专业
    getPostList() {
      this.isDisabled = false;
      this.imageUrl = "";
      http
        .getSpecial({
          entpId: this.entpId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.specialList = data.data.data;
            sessionStorage.setItem(
              "specialList",
              JSON.stringify(data.data.data)
            );
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },

    // 上传图片
    beforeAvatarUpload(file) {
      const isLt80k = file.size / 1024 < 80;
      if (!isLt80k) {
        this.$message.warning({
          duration: 1000,
          message: "上传图片大小不能超过 80k！"
        });
      }
      return isLt80k;
    },
    handleProgress(event, file, fileList) {
      // console.log(file, "handleProgress");
    },
    // 获取上传图片路径
    handleAvatarSuccess(res, file, fileList) {
      this.imageUrl = res.data;
      this.$refs.imageUrl.clearValidate();
    },
    CodeBtn() {
      http
        .getCode({
          phoneNumber: this.loginForm.phone,
          idcard: this.loginForm.card
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: data.data.message
            });
            this.isDisabled = true;
            setTimeout(() => {
              this.isDisabled = false;
            }, 60000);
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
      this.currentPage = val;
      this.getOrganList();
    },
    // 每页数
    handleSizeChange(val) {
      this.limit = val;
      this.currentPage = 1;
      this.getOrganList();
    },
    // 省市
    selected(data) {
      this.select.province = data.province.value;
      this.select.city = data.city.value;
    },
    // 选择省
    onChangeProvince(data) {
      this.select.province = data.value;
    },
    // 选择市
    onChangeCity(data) {
      this.select.city = data.value;
    },
    // 选择区
    onChangeArea(data) {
      console.log(data);
      this.select.area = data.value;
    },
    selectBtn() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getOrganList();
    },
    // 选择培训机构搜索
    getOrganList() {
      this.loading = true;
      this.select.province =
        this.select.province == "省" ? "" : this.select.province;
      this.select.city = this.select.city == "市" ? "" : this.select.city;
      http
        .getEnter({
          pageNum: this.currentPage,
          pageSize: this.limit,
          entpName: this.chooseForm.name,
          agentProvince: this.select.province, // 省
          agentCity: this.select.city // 市
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.organList = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    // 个人注册
    register(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .personRegister({
              regHeadportrait: this.imageUrl,
              regName: this.loginForm.name,
              regSex: this.loginForm.sex,
              regIdcard: this.loginForm.card,
              affiliatedEnterprise: this.loginForm.company,
              regTel: this.loginForm.phone,
              phoneVerificationCode: this.loginForm.code,
              regCertificateNum: this.loginForm.regCertificateNum,
              regCertificateDate: this.loginForm.regCertificateDate,
              postId: this.loginForm.special,
              regOldPost: this.loginForm.regOldPost,
              sysOrder: 1,
              entpId: this.entpId,
              learnYear: this.loginForm.learnYear
            })
            .then(data => {
              if (data.data.success == true) {
                this.chooseDialog = false;
                this.loginDialog = false;
                this.$confirm(
                  "注册成功！您的登录用户名是您的身份证号，密码是123456",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "success",
                    customClass: "show_confirm_black"
                  }
                )
                  .then(() => {
                    this.$router.push({
                      path: "/"
                    });
                  })
                  .catch(() => {
                    this.$message.info({
                      duration: 1000,
                      message: "已取消登陆"
                    });
                  });
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {
              // this.$message.error("请求失败,请联系管理员!");
            });
        } else {
          return false;
        }
      });
    },
    sign() {
      this.loginDialog = false;
      this.chooseDialog = false;
      this.ruleForm = {};
    },
    // 获取验证码
    getCodeBtn() {
      http
        .getCode({
          phoneNumber: this.forgetForm.phone,
          idcard: this.forgetForm.card
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: data.data.message
            });
            this.isDisabled = true;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    // 企业注册
    firmSure(formName) {},
    handleClick(tab, event) {
      if (tab.index == "0") {
        if (IsLocal) {
          window.location.replace("/");
        } else {
          window.location.replace("https://bdy.hbzclm.com");
        }
        // window.location.replace("http://localhost:8080/#/login");
        // window.location.replace("https://bdy.eceyun.net/#/");
      } else if (tab.index == "1") {
        if (IsLocal) {
          window.location.replace("/school/#/login");
        } else {
          window.location.replace("http://school.hbzclm.com");
        }
        // window.location.replace("http://localhost:8081/#/login");
        // window.location.replace("https://bdy.eceyun.net/school/#/login");
      } else if (tab.index == "2") {
        if (IsLocal) {
          window.location.replace("/manage/#/login");
        } else {
          window.location.replace("http://manager.hbzclm.com");
        }
        // window.location.replace("http://localhost:8082/#/login");
        // window.location.replace("https://bdy.eceyun.net/manage/#/login");
      }
      this.ruleForm = {};
      this.companyForm = {};
    },
    // 管理后台登录
    chartLogin() {},
    // 忘记密码 获取手机号
    getPhone() {
      var uname = this.forgetForm.card;
      if (uname) {
        http
          .getForgetPhone({
            uname: uname
          })
          .then(data => {
            if (data.data.code == "200" || data.data.success == true) {
              this.forgetForm.phone = data.data.message;
              this.phoneDisabled = true;
            } else {
              this.$message.error({
                duration: 1000,
                message: data.data.message
              });
              this.phoneDisabled = false;
              this.forgetForm.phone = "";
            }
          })
          .catch(error => {
            this.$message.error({
              duration: 1000,
              message: "请求失败,请联系管理员!"
            });
          });
      } else {
        return false;
      }
    },
    // 忘记密码  获取验证码
    getForgetBtn() {
      this.isDisabled = true;
      http
        .getForgetCode({
          uname: this.forgetForm.card
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              message: data.data.message
            });
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    // 忘记密码提交
    forgetCommit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          http
            .forgetPassword({
              userName: this.forgetForm.card,
              password: this.forgetForm.newpsd,
              verificationCode: this.forgetForm.code
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: data.data.message
                });
                this.forgetDialog = false;
                this.isDisabled = false;
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {
              this.$message.error({
                duration: 1000,
                message: "请求失败,请联系管理员!"
              });
            });
        } else {
          return false;
        }
      });
    },
    // 已经注册去登录
    firmLogin() {
      this.firmDialog = false;
      this.activeName = "second";
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__header {
  margin-bottom: 30px;
}
/deep/.el-tabs__nav {
  margin-left: 60px;
  // margin-left: 80px;
}
/deep/#tab-first {
  padding-left: 20px;
}
/deep/.distpicker-address-wrapper select {
  width: 160px !important;
}
.exam {
  width: 130px;
  height: 190px;
  margin-right: 20px;
  border: 1px dashed #ccc;
}
.avatar-uploader {
  width: 80%;
  height: 190px !important;
}
.avatar-uploader-icon {
  width: 130px;
  height: 190px;
  line-height: 190px;
}
/deep/.el-upload.el-upload--text {
  width: 130px;
  height: 190px;
}

.avatar {
  width: 100%;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.el-icon-plus.avatar-uploader-icon {
  line-height: 190px;
}
.el-upload__tip {
  top: 92% !important;
  margin-left: 10px;
  p {
    line-height: 24px;
  }
}

.home {
  height: 100%;
  background: url("../assets/images/bg.jpg") no-repeat center;
  background-size: cover;
  position: relative;
  .content {
    width: 450px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 13%;
    transform: translateX(-50%);
  }
  .title {
    color: rgb(49, 48, 48);
    text-align: center;
    margin-bottom: 20px;

    p {
      font-size: 30px;
      font-weight: 600;
      line-height: 50px;
    }
  }
  .login {
    background: #fff;
    border-radius: 6px;
    min-height: 330px;
    padding: 20px;
  }
  .tip {
    line-height: 50px;
    color: red;
    font-size: 18px;
    font-weight: 600;
  }
  .bot {
    /deep/.el-form-item__content {
      text-align: center;
      margin-left: 0 !important;
    }
    /deep/.el-button--primary {
      width: 60%;
    }
  }
  .enter {
    text-align: center;
    // margin-top: 10px;
    line-height: 40px;
    span {
      color: #409eff;
      text-decoration: underline;
      transition: 0.3s;
      &:hover {
        color: #66b1ff;
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1600px) {
    .top {
      font-size: 28px;
      top: 8%;
    }
    .forgetPop /deep/.el-dialog.el-dialog--center {
      width: 50% !important;
    }
    .choosePop /deep/.el-dialog.el-dialog--center {
      width: 60% !important;
    }
    .registerPop /deep/.el-dialog.el-dialog--center {
      width: 80% !important;
    }
  }
}

.info {
  // padding: 10px 30px;
  .line {
    .telbox {
      .code {
        margin-left: 10px;
      }
    }
    .sex {
      /deep/.el-radio {
        width: 20%;
        float: left;
      }
    }
    /deep/.el-form-item {
      width: 44%;
      // float: left;
      display: inline-block;
      margin-right: 50px;
    }
    /deep/.el-form-item__label {
      font-size: 16px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .create {
    /deep/.el-form-item__content {
      margin-left: 0 !important;
      text-align: center;
    }
  }
}
.forget {
  .telbox {
    .code {
      margin-left: 10px;
    }
  }
}
</style>
<style lang="less">
.show_Confirm_black {
  color: black;
}
.info.infoTeachingApplicate {
  padding: 10px;
  float: left;
  overflow: hidden;
}
</style>